import React from 'react';

import PropTypes from 'prop-types';

import {
    Section,
    Typography,
} from 'wanderu-components';
import appSettings from 'wanderu-config';
import { localize } from 'wanderu-i18n';

import styles from './ValueStatement.scss';

function getBucketPath() {
    return `${appSettings.config.s3.staticAssetsUrl}react-ui/media/general`;
}

function ValueStatement(props) {
    const {
        t,
        namespace,
    } = props;

    return (
        <Section>
            <div className={styles.root}>
                <img
                    alt=""
                    className={styles.image}
                    height="600"
                    loading="lazy"
                    src={`${getBucketPath()}/adventures.png`}
                    width="600"
                />
                <div>
                    <Typography
                        className={styles.title}
                        component="h2"
                        variant="h3"
                    >
                        {t(`${namespace}:valueStatementTitle`)}
                    </Typography>
                    <Typography>
                        {t(`${namespace}:valueStatementDescription`)}
                    </Typography>
                </div>
            </div>
        </Section>
    );
}

ValueStatement.propTypes = {
    namespace: PropTypes.string.isRequired,
};

export { ValueStatement };
export default localize(ValueStatement);
